import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { axiosConfig } from "../../axios/axiosConfig";

const WithdrawPaymentModals = ({ open, onClose, withdrawalId, onSuccess }) => {
  const [formData, setFormData] = useState({
    payment_method: "UPI",
    transaction_id: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    if (!formData.transaction_id || !formData.description) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        id: withdrawalId,
        ...formData,
      };

      const res = await axiosConfig({
        method: "post",
        url: "/tnibroadmin/pay-for-influencer/",
        data: payload,
      });

      toast.success(res?.data?.response || "Payment successful");
      onSuccess?.(); // refresh parent table
    } catch (err) {
      console.error(err);
      toast.error("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
      setFormData({
        payment_method: "UPI",
        transaction_id: "",
        description: "",
      });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Pay Influencer</DialogTitle>
      <DialogContent
        dividers
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <TextField
          label="Payment Method"
          name="payment_method"
          value={formData.payment_method}
          onChange={handleChange}
          select
          fullWidth
        >
          <MenuItem value="UPI">UPI</MenuItem>
          <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
          <MenuItem value="Cash">Cash</MenuItem>
        </TextField>
        <TextField
          label="Transaction ID"
          name="transaction_id"
          value={formData.transaction_id}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          fullWidth
          multiline
          rows={3}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Submit Payment"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WithdrawPaymentModals;
